import React from 'react';
import { useTranslation } from 'react-i18next';
import { CellTypes, TableDefinition, Column } from '~/Components/DataTable/DataTable.types';
import { makeStyles } from '~/UIKit/Style';
import { FONT_SIZE_MEDIUM, FONT_SIZE_SMALLISH } from '~/Constants/UI.constants';
import { ILocationWithStatus } from '~/Models/interfaces/Location.model';
import { LocationStatusTag } from '~/Components/LocationStatusTag';
import { LocationStatus } from '~/Models/DTO/externalParties.model';
import { addressFormatter } from './addressFormatter';

const useStyles = makeStyles(
  () => ({
    wrapper: {
      display: 'flex',
      alignItems: 'center',
    },
    text: {
      marginLeft: 15,
    },
    header: {
      fontSize: FONT_SIZE_MEDIUM,
      fontWeight: 700,
      lineHeight: '20px',
    },
    subHeader: {
      fontSize: FONT_SIZE_SMALLISH,
      fontWeight: 400,
      lineHeight: '20px',
    },
  }),
  { name: 'orgStudioListTable' },
);

export const useLocationsListDesktopTableDefinition = (): TableDefinition => {
  const { t } = useTranslation();
  const { classes } = useStyles();

  const columns: Column[] = [
    {
      label: t('form.field.name'),
      propertyIds: ['name'],
      cellType: CellTypes.String,
      formatter: ({ name }: ILocationWithStatus) => (
        <div>
          <div className={classes.header}> {name}</div>
        </div>
      ),
    },
    {
      style: { width: '410px' },
      label: t('form.field.location.address'),
      propertyIds: ['street', 'city', 'zipCode'],
      cellType: CellTypes.String,
      formatter: ({ city, street, zipCode }: ILocationWithStatus) => (
        <div>
          <div className={classes.subHeader}>{addressFormatter({ city, street, zipCode })}</div>
        </div>
      ),
    },
    {
      style: { width: '240px' },
      label: t('table.column.status'),
      propertyIds: 'status',
      cellType: CellTypes.String,
      formatter: (status: LocationStatus) => <LocationStatusTag status={status} />,
    },
  ];

  return {
    config: { useSelectableRows: true },
    columns,
  };
};
